import { Skeleton, SkeletonRow } from '../skeleton/Skeleton';

const OverviewNavigationSkeleton = () => (
  <div className='flex h-16 w-full items-center justify-center'>
    <Skeleton className='rounded-none'>
      <div className='flex flex-row gap-8 scroll-smooth whitespace-nowrap bg-white px-9 py-4'>
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <SkeletonRow className='h-5 min-w-28 md:h-6 md:min-w-44' />
        <blockquote></blockquote>
      </div>
    </Skeleton>
  </div>
);

export default OverviewNavigationSkeleton;
